<template>
  <div class="navModule">
    <div class="nav-item" v-for="(item,idx) in list" :key="item.name">
      <img :src="idx==0?item.tab_check_img:item.tab_normal_img" alt />
      <p :class="idx==0?'frist':''">{{item.tab_title}}</p>
    </div>
    <mask-btn-group
      @moveUp="$emit('moveUp',idx)"
      @moveDown="$emit('moveDown',idx)"
      @edit="$emit('edit',idx)"
      @del="$emit('del',idx)"
      :info="info"
      :idx="idx"
    ></mask-btn-group>
  </div>
</template>

<script>

import maskBtnGroup from './maskBtnGroup';
export default {
  name: 'navModule',
  props: {
    idx: [String, Number],
    info: Object,
    list:Array,
  },
  components: {
    maskBtnGroup,
  },
};
</script>

<style lang="scss" scoped>
.navModule {
  position: relative;
  padding-top: 5px;
  height: 48px;
  display: flex;
  background: #fff;
  .nav-item {
    flex: 1;
    text-align: center;
    img {
      width: 26px;
      height: 26px;
    }
    p {
      font-size: 12px;
      transform: scale(0.8);
    }
    .frist {
      color: #ff6766;
    }
  }
}
</style>